// Module
var code = `<template>
  <require from="./image-widget.scss"></require>
  <div class="image-widget image-widget-\${id}">
    <img src.bind="imageUrl" alt.bind="alt">
  </div>
</template>
`;
// Exports
export default code;